import { z } from "zod";

export const AiGetExperienceAnalysisDataRequestBodySchema = z.object({
  experienceId: z.string(),
  fileType: z.string().optional(),
  createdAt: z.number(),
  shopId: z.string(),
});

export type AiGetExperienceAnalysisDataRequestBodyType = z.infer<
  typeof AiGetExperienceAnalysisDataRequestBodySchema
>;

export const AiGetExperienceAnalysisDataResponseSchema = z.object({
  url: z.string(),
});

export type AiGetExperienceAnalysisDataResponseBodyType = z.infer<
  typeof AiGetExperienceAnalysisDataResponseSchema
>;
